import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 13c0 .5305-.2107 1.0392-.5858 1.4142C20.0391 14.7893 19.5304 15 19 15h-1v5h-5v-1c-.0022-.5295-.2144-1.0366-.59-1.41-.1834-.188-.4027-.3371-.645-.4385-.2422-.1013-.5024-.1529-.765-.1515-.5304 0-1.03914.2107-1.41421.5858C9.21071 17.9609 9 18.4696 9 19v1H4v-5h1c.53043 0 1.03914-.2107 1.41421-.5858C6.78929 14.0392 7 13.5305 7 13c0-.5304-.21071-1.0391-.58579-1.4142C6.03914 11.2107 5.53043 11 5 11H4V6.00003h5v-1c0-.53044.21071-1.03914.58579-1.41422.37507-.37507.88381-.58578 1.41421-.58578.2626-.0014.5228.05012.765.15149.2423.10137.4616.25051.645.43851.3756.37335.5878.88042.59 1.41v1h5V11h1c.5299.0016 1.0377.2128 1.4125.5876.3747.3747.5859.8825.5875 1.4124z",
    fill: "currentColor"
  }));
});